import { Card } from "@/design/primitives";

// One row per in-motion project — Airmail density for 20+ projects (council
// round 2026-10-21). Click opens the project detail with the phase runner.

export const WorkingRow = ({ card, onOpen }) => {
  const runner = card.runner || card.payload?.runner || null;
  const phases = runner?.phases || [];
  const doneCount = phases.filter((x) => x.status === "done").length;
  const phaseLine =
    phases.length > 0
      ? `Phase ${Math.min(doneCount + 1, phases.length)} of ${phases.length}`
      : (card.phaseCount ? `${card.phaseCount} planned steps` : "");
  const lastUpdate =
    phases.filter((x) => x.update).slice(-1)[0]?.update || card.lastKitAction;
  return (
    <Card
      role="button"
      tabIndex={0}
      data-testid={`project-row-${card.slug}`}
      data-state={card.rawState}
      aria-label={`${card.title}, ${card.brand}. Open details`}
      onClick={() => onOpen(card.slug)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), onOpen(card.slug))}
      className="flex cursor-pointer flex-wrap items-baseline gap-x-3 gap-y-1 px-4 py-3 text-left hover:border-os-border-strong focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-os-ink"
    >
      <span className="min-w-0 flex-[1] basis-48 truncate font-semibold tracking-[-0.01em] text-os-ink">
        {card.title}
      </span>
      {phaseLine && (
        <span className="font-mono text-[0.625rem] uppercase tracking-[0.08em] text-os-ink-3">{phaseLine}</span>
      )}
      {lastUpdate && (
        <span data-testid={`row-last-${card.slug}`} className="min-w-0 flex-[2] basis-64 truncate text-[0.8125rem] text-os-ink-3">
          {lastUpdate}
        </span>
      )}
      {card.lastActivityAt && (
        <span className="ml-auto font-mono text-[0.625rem] text-os-ink-4">{card.lastActivityAt}</span>
      )}
    </Card>
  );
};

export default WorkingRow;
